import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimmer, Loader, Message } from "semantic-ui-react";
import SummaryReport from "./../SummaryReport";
import axios from "axios";
import parse from "url-parse";
import SummaryReportHeader from "../../components/SRHHeaders/SummaryReportHeader";
import _ from "lodash";

class SharedSummaryReport extends Component {
  constructor(props) {
    super(props);
    const token = this.props.match.params.token;
    this.state = {
      token,
      error: null,
      id: null,
      sharedSummaryReport: null,
    };
    axios
      .get(`/api/shared-summary-reports/${token}`)
      .then(res => {
        const unit = parse(this.props.location.search, true).query.unit;
        if (
          res.data.datasetId &&
          res.data.resultSetId &&
          ((res.data.sharedHospital && !unit) ||
            _.includes(res.data.sharedUnits, "*") ||
            _.includes(res.data.sharedUnits, unit))
        ) {
          this.setState({
            id: res.data.reportId,
            sharedSummaryReport: res.data,
          });
        } else {
          this.setState({
            error: "Error: your link is expired or invalid",
          });
        }
      })
      .catch(err => {
        this.setState({
          error: "We encountered an error. Try reloading the page.",
        });
      });
  }

  render() {
    const { id, sharedSummaryReport, error } = this.state;
    if (id) {
      return (
        <SummaryReport
          id={id}
          sharedSummaryReport={sharedSummaryReport}
          location={this.props.location}
          history={this.props.history}
        />
      );
    } else if (error) {
      return (
        <div>
          <SummaryReportHeader />
          <div
            style={{
              margin: "auto",
              width: "800px",
              paddingTop: "50px",
            }}
          >
            <Message error header={error} />
          </div>
        </div>
      );
    } else {
      return (
        <Dimmer active>
          <Loader />
        </Dimmer>
      );
    }
  }
}

export default connect(store => {
  return {};
})(SharedSummaryReport);



// WEBPACK FOOTER //
// ./src/pages/SharedSummaryReport/index.jsx